<template>
  <aside
    id="sidebar"
    class="bg-[#8DC63F] text-black lg:w-80 w-3/4 space-y-6 pt-6 px-0 absolute inset-y-0 left-0 transform lg:relative lg:translate-x-0 transition duration-200 ease-in-out lg:flex lg:flex-col lg:justify-between overflow-y-auto border border-x-neutral-400 z-30"
  >
    <div
      class="flex flex-col space-y-6"
      data-dev-hint="optional div for having an extra footer navigation"
    >
      <img
        src="../assets/AccessArmLogo.webp"
        class="mx-auto pt-[30px] w-40 bg-cover"
        width="100"
        alt=""
      />
      <nav data-dev-hint="main navigation">
        <router-link
          to="/user/dashboard"
          class="flex items-center space-x-2 py-2 px-4 transition duration-200 hover:bg-[#96b965] hover:text-white"
        >
          <span
            class="ml-6"
            :class="
              currentRoute === 'dashboard' ? 'sidebar-active' : 'text-black'
            "
          >
            <font-awesome-icon icon="fa-home" />
            <span class="text-[17px] ml-4">Dashboard</span>
          </span>
        </router-link>

        <router-link
          to="/user/contribution-schedule"
          class="flex items-center space-x-2 py-2 px-4 transition duration-200 hover:bg-[#96b965] hover:text-white"
        >
          <div
            class="ml-6"
            :class="
              currentRoute === 'contribution-schedule'
                ? 'sidebar-active'
                : 'text-white'
            "
          >
            <font-awesome-icon icon="fa-calendar-alt" />
            <span class="text-[17px] ml-[1.3rem]">Contribution Schedule</span>
          </div>
        </router-link>

        <router-link
          to="/user/employee-list"
          class="flex items-center space-x-2 py-2 px-4 transition duration-200 hover:bg-[#96b965] hover:text-white"
        >
          <span
            class="ml-6"
            :class="
              currentRoute.includes('employee')
                ? 'sidebar-active'
                : 'text-white'
            "
          >
            <font-awesome-icon class="" icon="fa-users" />
            <span class="text-[17px] ml-4">Employees List</span>
          </span>
        </router-link>

        <router-link
          to="/user/exited-employees"
          class="flex items-center space-x-2 py-2 px-4 transition duration-200 hover:bg-[#96b965] hover:text-white"
        >
          <span
            class="ml-6"
            :class="
              currentRoute === 'exited-employees'
                ? 'sidebar-active'
                : 'text-black'
            "
          >
            <font-awesome-icon icon="fa-user-lock" />
            <span class="text-[17px] ml-4">Exited Employees</span>
          </span>
        </router-link>

        <router-link
          to="/user/payment-history"
          class="flex items-center space-x-2 py-2 px-4 transition duration-200 hover:bg-[#96b965] hover:text-white"
        >
          <span
            class="ml-6"
            :class="
              currentRoute === 'payment-history' ||
              currentRoute === 'payment-history-details'
                ? 'sidebar-active'
                : 'text-black'
            "
          >
            <font-awesome-icon class="" icon="fa-money-check" />
            <span class="text-[17px] ml-4">Payment History</span>
          </span>
        </router-link>

        <router-link
          to="/user/tickets"
          class="flex items-center space-x-2 py-2 px-4 transition duration-200 hover:bg-[#96b965] hover:text-white"
        >
          <span
            class="ml-6"
            :class="
              currentRoute === 'tickets' ? 'sidebar-active' : 'text-black'
            "
          >
            <font-awesome-icon class="" icon="fa-mail-bulk" />
            <span class="text-[17px] ml-4">Tickets</span>
          </span>
        </router-link>

        <router-link
          to="/user/profile"
          class="flex items-center space-x-2 py-2 px-4 transition duration-200 hover:bg-[#96b965] hover:text-white"
        >
          <span
            class="ml-6"
            :class="
              currentRoute === 'profile' ? 'sidebar-active' : 'text-black'
            "
          >
            <font-awesome-icon class="" icon="fa-user" />
            <span class="text-[17px] ml-6">Profile</span>
          </span>
        </router-link>

        <div
          class="flex items-center space-x-2 py-2 px-4 transition duration-200 hover:bg-[#96b965] hover:text-white"
        >
          <span class="ml-2">
            <font-awesome-icon class="text-white" icon="fas fa-sign-out" />
            <span
              @click="toggleModalOpen"
              class="text-[17px] ml-5 text-white cursor-pointer"
              >Logout</span
            >
          </span>
        </div>
      </nav>
    </div>
  </aside>
</template>

<script>
export default {
  props: {
    currentRoute: String,
    isModalOpen: Boolean,
    toggleModalOpen: Function,
  },
};
</script>

<style scoped>
aside span {
  font-size: 14px;
  color: white !important;
}

aside a {
  padding: 16px 0;
}

.router-link-active {
  background-color: white;
}

.router-link-active span {
  color: #8dc63f !important;
}

#sidebar {
  --tw-translate-x: -100%;
}

@media (min-width: 1024px) {
  #sidebar {
    --tw-translate-x: 0;
  }

  aside span {
    font-size: 12px;
  }
}

@media (min-width: 1024px) {
  aside span {
    font-size: 16px;
  }
}
</style>
